<!-- @format -->

<import-complete>
  <style>
    .message {
      font-size: 2rem;
      line-height: 1em;
      margin: 48px;
    }
  </style>
  <div class="container_contents">
    <div is="index-tag">
      <div class="container_breadcrumb">
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <h1 class="heading-01 heading_home">edirecoからの登録</h1>
          </li>
        </ul>
      </div>
      <div class="contents">
        <section class="contents_area">
          <div class="contents_block detail" style="text-align: center">
            <img src="/assets/img/logo.svg" width="480" />
            <div class="message">
              「edireco」からの登録、コピーが完了しました！
            </div>
            <div class="box_flex03">
              <a class="button button-primary" href="/menu/public-info">
                コピーした内容を確認する
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <!--/.container_contents-->

  <script>
    import di from "dependency-injection";
    import qs from "qs";

    export default {
      onMounted() {
        const q = qs.parse(location.search.slice(1));
        switch (q.login) {
          case "2":
            window.analytics.event("sign_up", { method: "bizid" });
            break;
        }
        switch (q.event) {
          case "import":
            window.analytics.event("unlock_achievement", {
              achievement_id: "import_from_edireco",
            });
            break;
        }
        window.history.replaceState({}, document.title, location.pathname);
      },
    };
  </script>
</import-complete>
